import Reveal from "@/components/base/Reveal";
import { guideSteps } from "@/mocks/homeData";

export default function GuideSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.2em] text-secondary-600">HOW TO READ</span>
          <h3 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            三步看懂这份时间线
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            不需要从头翻到尾。按下面三步走，几分钟就能建立对整件事的完整印象。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {guideSteps.map((step, index) => (
            <Reveal key={step.no} delay={index * 100}>
              <div className="h-full rounded-lg border border-background-200/80 bg-background-50 p-6">
                <div className="flex items-center justify-between">
                  <span className="font-label text-3xl text-background-300 md:text-4xl">{step.no}</span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${step.icon} text-xl`}></i>
                  </span>
                </div>
                <h4 className="mt-5 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {step.title}
                </h4>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}